import { createStore, createTypedHooks } from 'easy-peasy';
import { userExampleStore } from 'features/userExampleFeature';
import { fileUploadStore } from 'features/files';
import { modalManagerStore } from 'features/modalManager';
import { urlStateStore } from 'features/urlState';
import { meStore } from './me';
import type { GlobalStore } from './types';

// import and add feature stores to the global store
const globalStores: GlobalStore = {
  userExample: userExampleStore,
  fileUpload: fileUploadStore,
  modalManager: modalManagerStore,
  me: meStore,
  urlState: urlStateStore,
};

// Export typed hooks
export const typedHooks = createTypedHooks<GlobalStore>();
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;

// Create and export store
export const globalStore = createStore<GlobalStore>(globalStores);
